const renderCodeStatus = (statusDescription) => {
  const status = {
    AGUARDANDO: '1',
    APROVADO: '2',
    CANCELADO: '3',
    VENCIDO: '4',
    PAGO: '6',
  }

  return status[statusDescription];
};

export default renderCodeStatus;
